import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Settings } from '../../core';
import { EQueryCreateData } from './models/e-query-create-data';
import { deserialize, dataMember, required } from 'santee-dcts';

export const enum EQueryCreateErrorType {
    ActiveEQueryChanged = 'ActiveEQueryChanged'
}

class EQueryCreateError {
    @dataMember()
    @required()
    public errorType: EQueryCreateErrorType;
}

@Injectable()
export class EQueryStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
    ) {
    }

    public async createEQuery(eQuery: EQueryCreateData): Promise<null | EQueryCreateErrorType> {
        const formData: FormData = new FormData();
        const descriptions: string[] = [];

        if (eQuery.files) {
            const fileContent = eQuery.files.keys();

            for (let file of fileContent) {
                formData.append('file', file, file.name);
                if (eQuery.files.has(file)) {
                    descriptions.push(eQuery.files.get(file));
                } else {
                    descriptions.push('');
                }
            }
        }
        formData.append('eQueryPostRequest', JSON.stringify(eQuery));
        formData.append('fileDescriptions', JSON.stringify(descriptions));

        try {
            await this.http.post(`${this.settings.apiUrl}/coordinator/e-queries`, formData).toPromise();
            return null;
        } catch (e) {
            if (e instanceof HttpErrorResponse) {
                if (e.status === 409 && this.isActiveEQueryChanged(e.error)) {
                    return deserialize(e.error, EQueryCreateError).errorType;
                }
            }
            throw e;
        }
    }

    private isActiveEQueryChanged(response: any): response is EQueryCreateError {
        return response && (response as EQueryCreateError).errorType === EQueryCreateErrorType.ActiveEQueryChanged;
    }
}